import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { css, styled } from 'styled-components';
import { Box } from "../../../box/src";
import { __ } from "../../../i18n/src";
import { zIndices } from "../../../theme/src";
import { SubMenuItem } from './SubMenuItem';
const SubMenu = (_a) => {
    var _b, _c;
    var { isMobile, menuItem, menuStyle, showSubMenu, subMenuPosition, subMenuRef } = _a, props = __rest(_a, ["isMobile", "menuItem", "menuStyle", "showSubMenu", "subMenuPosition", "subMenuRef"]);
    const { key, label } = menuItem;
    const subItems = isMobile
        ? [Object.assign(Object.assign({}, menuItem), { isMobileMenuItem: true }), ...((_b = menuItem.subItems) !== null && _b !== void 0 ? _b : [])]
        : (_c = menuItem.subItems) !== null && _c !== void 0 ? _c : [];
    const positionLeftRightStyle = isMobile
        ? {
            left: 0,
            right: 0,
        }
        : {
            left: `${(subMenuPosition === null || subMenuPosition === void 0 ? void 0 : subMenuPosition.left) ? `${subMenuPosition === null || subMenuPosition === void 0 ? void 0 : subMenuPosition.left}px` : 'unset'}`,
            right: `${(subMenuPosition === null || subMenuPosition === void 0 ? void 0 : subMenuPosition.right) && !(subMenuPosition === null || subMenuPosition === void 0 ? void 0 : subMenuPosition.left) ? `${subMenuPosition === null || subMenuPosition === void 0 ? void 0 : subMenuPosition.right}px` : 'unset'}`,
        };
    return (_jsx(SubMenuItemsWrapper, { "$isMobile": isMobile, "$menuStyle": menuStyle, "aria-label": __('%{label} submenu').i__({
            label,
        }), as: "ul", id: `subMenu-${key}`, ref: subMenuRef, role: "menu", style: Object.assign(Object.assign({ visibility: showSubMenu ? 'visible' : 'hidden', opacity: showSubMenu ? 1 : 0 }, positionLeftRightStyle), { top: `${(subMenuPosition === null || subMenuPosition === void 0 ? void 0 : subMenuPosition.top) ? `${subMenuPosition === null || subMenuPosition === void 0 ? void 0 : subMenuPosition.top}px` : 'unset'}` }), children: subItems.map((subItem, index) => (_jsx(SubMenuItem, Object.assign({ isMobile: isMobile, itemIndex: index, subItem: subItem }, props), subItem.key))) }));
};
export default SubMenu;
const SubMenuItemsWrapper = styled(Box).attrs(({ $isMobile }) => ({
    mt: $isMobile ? 3 : 1,
})) `
  position: fixed;
  border-radius: ${({ $isMobile }) => ($isMobile ? 0 : `4px`)};
  flex-direction: column;
  min-width: min-content;
  padding: 8px 0;
  z-index: ${zIndices.pinned};

  &:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 4px;
    top: -4px;
    left: 0;
  }

  ${({ $menuStyle, theme }) => css `
    background-color: ${$menuStyle.backgroundColor};
    box-shadow: ${theme.dropdown.boxShadow};
  `}
`;
//# sourceMappingURL=SubMenu.js.map